export enum RetentionPeriods {
  Indefinitely = 'indefinitely',
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}
